import React from 'react';
import { futuresPositions } from '../../utils/portfolioData';
export function PositionPerformanceTable() {
  return <div className="glass-border rounded-[20px] overflow-hidden" data-id="element-187">
      <div className="p-6 border-b border-border-subtle" data-id="element-188">
        <h3 className="text-sm font-heading text-text-primary" data-id="element-189">
          Position Performance
        </h3>
      </div>
      <div className="overflow-x-auto" data-id="element-190">
        <table className="w-full text-left border-collapse" data-id="element-191">
          <thead data-id="element-192">
            <tr className="border-b border-border-subtle" data-id="element-193">
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium" data-id="element-194">
                Pair
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium" data-id="element-195">
                Side
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-196">
                Size
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-197">
                Entry Price
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-198">
                Mark Price
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-199">
                Leverage
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-200">
                Unrealized P&L ($)
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-201">
                P&L (%)
              </th>
            </tr>
          </thead>
          <tbody data-id="element-202">
            {futuresPositions.map(pos => {
            const isProfit = pos.unrealizedPnl >= 0;
            return <tr key={pos.symbol} className="border-b border-border-subtle last:border-0 hover:bg-white/[0.02] transition-colors" data-id="element-203">
                  <td className="py-4 px-6" data-id="element-204">
                    <div className="flex items-center gap-3" data-id="element-205">
                      <img src={pos.logo} alt={pos.symbol} className="w-6 h-6 rounded-full" data-id="element-206" />
                      <div className="text-sm font-medium text-text-primary" data-id="element-207">
                        {pos.pair}
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6" data-id="element-208">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${pos.side === 'Long' ? 'bg-success/10 text-success' : 'bg-danger/10 text-danger'}`} data-id="element-209">
                      {pos.side}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-primary" data-id="element-210">
                    {pos.size}
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-secondary" data-id="element-211">
                    $
                    {pos.entryPrice.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-primary" data-id="element-212">
                    $
                    {pos.markPrice.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className="py-4 px-6 text-right" data-id="element-213">
                    <span className="px-1.5 py-0.5 bg-brand-purple/10 text-brand-purple-light text-[10px] font-medium rounded" data-id="element-214">
                      {pos.leverage}x
                    </span>
                  </td>
                  <td className={`py-4 px-6 text-right font-numbers text-sm ${isProfit ? 'text-success' : 'text-danger'}`} data-id="element-215">
                    {isProfit ? '+' : ''}$
                    {pos.unrealizedPnl.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className={`py-4 px-6 text-right font-numbers text-sm ${isProfit ? 'text-success' : 'text-danger'}`} data-id="element-216">
                    {isProfit ? '+' : ''}
                    {pos.unrealizedPnlPercent.toFixed(2)}%
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}